module.exports = __webpack_public_path__ + "static/media/slide (2).1ac96317.jpg";